import React from 'react';
import classes from './Loaders.module.scss'

const LoadingSpinner = () => {
    return (
        <div className={classes.loadingSpinner}></div>
    );
};

export default LoadingSpinner;